import { useState } from "react";
import { Grid, Button } from "@material-ui/core";
import { FPaquetesStyle } from "./styles";
import Origen from "./Origen";
import Destinos from "./Destinos";
import HeaderModal from "../../../global/headerModal";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import ExploreIcon from "@material-ui/icons/Explore";
import ModalBase from "./../../../global/ModalBase";
const FPaquetesDestinos = (props) => {
  const { open = true, setOpen = () => {}, rowData = {} } = props;
  const [isOrigen, setIsOrigen] = useState(false);
  const classes = FPaquetesStyle();
  const handleChangeOrgien = () => {
    setIsOrigen(!isOrigen);
  };
  const handleClose = () => {
    setOpen(!open);
    setIsOrigen(false);
  };
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal
        handleClose={handleClose}
        titulo={(rowData.Origen && !isOrigen) ? `Destinos para el paqute ${rowData.Nombre}` : `Origen para el paqute ${rowData.Nombre}`}
      >
        <Grid container className={classes.containerSpacingLabel}>
          <Grid item xs={12}>
            {rowData.Origen || isOrigen ? (
              <div className={classes.flexSpacing}>
                <h3>{`Origen: ${rowData.Origen.Nombre}`}</h3>
                <IconButton
                  aria-label="closeModal"
                  onClick={handleChangeOrgien}
                >
                  {!isOrigen ? <EditIcon /> : <ExploreIcon />}
                </IconButton>
              </div>
            ) : null}
          </Grid>
        </Grid>
      </HeaderModal>
      {!rowData.Origen || isOrigen ? (
        <Origen idPaquete={rowData.IdPaquete} setOpen={setOpen} setIsOrigen={setIsOrigen} />
      ) : (
        <Destinos idPaquete={rowData.IdPaquete} />
      )}

      <Grid container className={classes.containerSpacing}>
        <Grid item xs={12} className={classes.modalBotonesCenter}>
          {
            (rowData.Origen && !isOrigen) &&          <Button
            onClick={handleClose}
            variant="contained"
            color="primary"
            className={classes.modalBoton}
          >
            Aplicar
          </Button>
          }

        </Grid>
      </Grid>
    </ModalBase>
  );
};
export default FPaquetesDestinos;
